/**
 * Date formatting utilities
 * Centralized date formatting to avoid code duplication
 */

/**
 * Formats a date for display with consistent format in HKT timezone
 * @param {string|Date} timestamp - Date to format
 * @returns {string} Formatted date string in HKT
 */
export const formatMatchDate = timestamp => {
  if (!timestamp) return 'Just now';

  const date = new Date(timestamp);
  const dateString = date
    .toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      timeZone: 'Asia/Hong_Kong',
    })
    .replace(/,/g, '');

  const timeString = date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Asia/Hong_Kong',
    hour12: false,
  });

  return `${dateString}, ${timeString} HKT`;
};

/**
 * Formats just the date part without time
 * @param {string|Date} timestamp - Date to format
 * @returns {string} Formatted date string
 */
export const formatDateOnly = timestamp => {
  if (!timestamp) return '';

  const date = new Date(timestamp);
  return date
    .toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })
    .replace(/,/g, '');
};

/**
 * Formats just the time part without date
 * @param {string|Date} timestamp - Date to format
 * @returns {string} Formatted time string
 */
export const formatTimeOnly = timestamp => {
  if (!timestamp) return '';

  const date = new Date(timestamp);
  return date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });
};
